import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import { useAuthStore } from "@/store/authStore";
import { demoAdminDashboard } from "@/data/demoData";
import { unwrapApiObject } from "@/lib/api-response";

export function useAdminDashboard() {
  const { user } = useAuthStore();

  return useQuery({
    queryKey: ["admin-dashboard"],
    queryFn: async () => {
      if (user?.isDemo) {
        return demoAdminDashboard;
      }
      const res = await apiClient.get("/admin/dashboard/stats");
      return unwrapApiObject(res, null as any);
    },
  });
}
